var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sameday-services-filter',{attrs:{"params":{ services: _vm.services, ..._vm.params },"search":_vm.search},on:{"has:services":function($event){return _vm.$emit('has:services', $event)}},scopedSlots:_vm._u([{key:"default",fn:function({ filteredServices }){return _vm._l((filteredServices),function(el,key){return _c('sameday-service',{key:key,attrs:{"params":{
      ...el,
      location: _vm.params,
    }},on:{"on:form":function($event){return _vm.$emit('on:form', $event)}}})})}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }